import React from "react";
import "./TermsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> [Insert Date]</p>
      <p><strong>Business Name:</strong> Indvo - Gateway of Indian Market</p>
      <p><strong>Services Covered:</strong> Business Expansion Infrastructure & Sourcing Agent Services</p>
      <p><strong>Contact:</strong> Contact@indvo.com</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By using the services offered by Global Expansion Gateway (“we,” “our,” or “us”), you (“client,” “you,” or “user”) agree to comply with and be legally bound by these Terms of Service.</p>
      <p>If you do not agree to these terms, you may not use our services.</p>

      <h2>2. Services Offered</h2>
      <ul>
        <li>🛒 Business Expansion Services (India Market): logistics, warehousing, payment setup, compliance support, etc.</li>
        <li>🔍 Sourcing Agent Services: manufacturer identification, pricing, procurement management.</li>
      </ul>

      <h2>3. Eligibility</h2>
      <ul>
        <li>Must be 18+</li>
        <li>Have a registered business</li>
        <li>Be authorized to enter contracts</li>
        <li>Have defined manufacturing needs or ready-for-sale products</li>
      </ul>

      <h2>4. Trial Period and Paid Plans</h2>
      <ul>
        <li>6-month free trial (Basic Plan)</li>
        <li>Post-trial: $49/month</li>
        <li>Standard ($999) & Enterprise ($9,999) plans via approval</li>
        <li>Sourcing projects may have custom pricing</li>
      </ul>

      <h2>5. Client Responsibilities</h2>
      <ul>
        <li>Accurate business/product info</li>
        <li>Legal ownership assurance</li>
        <li>Responsive communication</li>
        <li>No false performance data</li>
      </ul>

      <h2>6. Payment Terms</h2>
      <ul>
        <li>Billed monthly unless agreed otherwise</li>
        <li>Non-refundable fees</li>
        <li>Higher-tier upgrades billed on acceptance</li>
        <li>Late payments may pause services</li>
      </ul>

      <h2>7. Sales Guarantees</h2>
      <ul>
        <li>Standard: $1M/yr revenue</li>
        <li>Enterprise: $10M/yr revenue</li>
        <li>Shortfalls = continued service at no cost</li>
      </ul>

      <h2>8. Intellectual Property</h2>
      <p>Our tools, templates, and strategy remain our IP. You own your brand and product content.</p>

      <h2>9. Limitation of Liability</h2>
      <p>We’re not liable for customs issues, platform suspensions, or supplier problems. Liability is capped at fees paid in the last 3 months.</p>

      <h2>10. Termination</h2>
      <p>You may cancel anytime in writing. We may terminate service due to violations or missed payments.</p>

      <h2>11. Confidentiality</h2>
      <p>Your business data stays private and is only shared with authorized partners needed for service delivery.</p>

      <h2>12. Dispute Resolution</h2>
      <p>Disputes should first be handled mutually. If unresolved, local governing law applies.</p>

      <h2>13. Modifications</h2>
      <p>Terms may be updated. Continued use = agreement with new terms.</p>

      <h2>14. Contact</h2>
      <p>📧 Email: Contact@indvo.com</p>
      <p>🌐 Website: www.indvo.com</p>
      <p>📍 Address: Behind Mata Mandir, Chandangaon, Chhindwara 480001, MP, India</p>
    </div>
  );
};

export default TermsOfService;
